export const headers = [
  {
    key: 'name',
    name: 'Nombre',
  },
  {
    key: 'description',
    name: 'Descripción',
  },
  {
    key: 'status',
    name: 'Estado',
  },
  {
    key: 'total_questions',
    name: 'Preguntas',
  },
]
